export const staffToday=()=>{const d=new Date();return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`};
export const staffDays=(date:string)=>Math.floor((Date.parse(staffToday())-Date.parse(date.slice(0,10)))/86400000);
export const staffPhone=(phone?:string|null)=>(phone||"").replace(/(\d{3})(\d{4})(\d{4})/,"$1 $2 $3");
export const staffCanResolveDuplicate=(matches:{id:string}[])=>matches.length===1;
export function staffNextCode(codes:string[]) {
  const used=new Set(codes);let next=1;
  while(used.has(String(next).padStart(3,"0")))next++;
  return String(next).padStart(3,"0");
}
export function staffPeriodRange(period:string,from:string,to:string) {
  const today=new Date(staffToday()+"T00:00:00Z"),y=today.getUTCFullYear(),m=today.getUTCMonth();
  const iso=(date:Date)=>date.toISOString().slice(0,10);
  if(period==="custom")return[from,to];
  if(period==="month")return[iso(new Date(Date.UTC(y,m,1))),iso(today)];
  if(period==="last")return[iso(new Date(Date.UTC(y,m-1,1))),iso(new Date(Date.UTC(y,m,0)))];
  if(period==="3m")return[iso(new Date(Date.UTC(y,m-2,1))),iso(today)];
  return[`${y}-01-01`,iso(today)];
}
const months:Record<string,string>={Jan:"يناير",Feb:"فبراير",Mar:"مارس",Apr:"أبريل",May:"مايو",Jun:"يونيو",Jul:"يوليو",Aug:"أغسطس",Sept:"سبتمبر",Sep:"سبتمبر",Oct:"أكتوبر",Nov:"نوفمبر",Dec:"ديسمبر"};
export const staffDate=(date?:string|null,rtl=false)=>{
  if(!date)return "—";
  const value=new Date(date.slice(0,10)+"T00:00:00Z").toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric",timeZone:"UTC"});
  return rtl?value.replace(/[A-Za-z]+/g,month=>months[month]||month):value;
};
const governorates:Record<string,string>={"01":"Cairo","02":"Alexandria","03":"Port Said","04":"Suez","11":"Damietta","12":"Dakahlia","13":"Sharqia","14":"Qalyubia","15":"Kafr El Sheikh","16":"Gharbia","17":"Monufia","18":"Beheira","19":"Ismailia","21":"Giza","22":"Beni Suef","23":"Fayoum","24":"Minya","25":"Assiut","26":"Sohag","27":"Qena","28":"Aswan","29":"Luxor","31":"Red Sea","32":"New Valley","33":"Matrouh","34":"North Sinai","35":"South Sinai","88":"Outside Egypt"};
export function readStaffId(value:string) {
  const x=value.replace(/\D/g,"");
  if(x.length!==14)return{ok:false,msg:x.length?`${x.length} of 14 digits`:""};
  if(!"23".includes(x[0]))return{ok:false,msg:"Should start with 2 or 3"};
  const year=(x[0]==="2"?1900:2000)+Number(x.slice(1,3)),month=Number(x.slice(3,5)),day=Number(x.slice(5,7)),birth=new Date(Date.UTC(year,month-1,day));
  if(birth.getUTCMonth()!==month-1||birth.getUTCDate()!==day)return{ok:false,msg:"The birth date inside the ID isn't valid"};
  const gov=governorates[x.slice(7,9)];
  if(!gov)return{ok:false,msg:"The governorate code isn't valid"};
  return{ok:true,msg:`Born ${staffDate(birth.toISOString())} · ${gov} · age ${Math.floor((Date.now()-birth.getTime())/(365.25*86400000))}`};
}
